import React from 'react';
import { useIntl } from 'react-intl';

import { Icon, PressableProps, Text } from '@fhs-legacy/universal-components';
import { primitive } from 'styles/constants/primitives';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import { IconContainer, PlusIconContainer, StyledPressable } from './loyalty-promo-code-cta.styled';

export const LoyaltyPromoCodeCTA = ({ onPress }: PressableProps) => {
  const { formatMessage } = useIntl();

  return (
    <StyledPressable onPress={onPress}>
      <IconContainer>
        <Icon
          variant="offer"
          color={primitive.$white}
          {...hiddenAccessibilityPlatformProps}
          size={6}
        />
      </IconContainer>
      <Text fontWeight="bold">{formatMessage({ id: 'promoCodeCTA' })}</Text>
      <PlusIconContainer>
        <Icon variant="add" {...hiddenAccessibilityPlatformProps} />
      </PlusIconContainer>
    </StyledPressable>
  );
};
